import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isMobileMode, isKiteUser } = {}) => ({
    reorderButton: { maxHeight: '34px', width: 276, alignSelf: 'center' },
    flatIconButton: { padding: 0, alignSelf: 'start' },
    reorderButtonWide: { width: '119px', height: '36px' },
    card: {
      position: 'relative',
      display: 'flex',
      flexDirection: isMobileMode ? 'column' : 'row',
      height: isMobileMode ? '130px' : '107px',
      padding: isMobileMode ? '10px' : '20px',
      backgroundColor: 'white',
      boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
      borderRadius: '20px',
      marginBottom: theme.spacing(3),
      '& > *': {
        flexGrow: !isMobileMode && 1,
      },
      [theme.breakpoints.down('md')]: {
        borderRadius: 10,
        marginBottom: theme.spacing(1.5),
      },
    },
    kitName: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      color: !isMobileMode && theme.palette.darkGrey,
    },
    kitDetailsLink: {
      color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
      textDecoration: 'none',
      maxHeight: '40px',
      paddingRight: theme.spacing(3),
    },
    mobileTotalQty: {
      flexGrow: 1,
      paddingTop: theme.spacing(0.75),
      color: theme.palette.darkGrey,
    },
    tabletTotalQtyValue: {
      color: theme.palette.darkGrey,
    },
    detailsIcon: {
      marginLeft: -5,
    },
    removeIcon: {
      position: 'absolute',
      right: 10,
      top: 10,
      '& svg': {
        height: 22,
        width: 22,
      },
    },
  }),
);
